import Toast from '../Toast/index'
import { mapGetters } from 'vuex'
export default {
  name: 'PageHeader',
  components: { Toast },
  props: ['paymentAlert', 'activeLink'],
  data () {
    return {
      dropdownOpen: false,
      activeRoute: 'Home'
    }
  },
  computed: {
    ...mapGetters([
      'alertMessage',
      'userType',
      'upi_enabled',
      'user'
    ])
  },
  mounted () {
    this.activeRoute = this.$route.params.name
  },
  methods: {
    goHome () {
      this.$router.push({ name: 'Home' })
    },
    logout () {
      this.$store.dispatch("storeMixpanelEvent", {
        eventName: "SCREEN",
        propertyName: "SCREEN_NAME",
        propertyValue: "LOGOUT"
      });
      this.$store.dispatch('logout').then(() => {
        this.$store.commit('setLoginState', false)
        this.$router.push({ name: 'Login' })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/PageHeader/component.js